<template>
  <div class="popup popup--more" id="more">
    <div class="popup__block">
      <div class="popup__close popup__close--back"></div>
      <div class="popup__title">Информация о заказе №{{ moduleOrdersHistory.currentOrder.id }}</div>
      <div class="popup-more">
        <div class="basket__success">
          <div class="b-success">
            <div class="b-success__items">
              <div class="b-success__item">
                <div class="b-success__item-title">Тип оплаты</div>
                <div class="b-success__item-value">{{ moduleOrdersHistory.currentOrder.paymentType }}</div>
              </div>
              <div class="b-success__item">
                <div class="b-success__item-title">Доставка</div>
                <div class="b-success__item-value">{{ moduleOrdersHistory.currentOrder.deliveryType }}</div>
              </div>
              <div v-show="moduleOrdersHistory.currentOrder.address" class="b-success__item">
                <div class="b-success__item-title">Адрес</div>
                <div class="b-success__item-value">{{ moduleOrdersHistory.currentOrder.address }}</div>
              </div>
              <div v-if="moduleOrdersHistory.currentOrder.comment" class="b-success__item">
                <div class="b-success__item-title">Комментарий к заказу</div>
                <div class="b-success__item-value">{{moduleOrdersHistory.currentOrder.comment}}</div>
              </div>
              <div class="b-success__item">
                <div class="b-success__item-title">Стоимость доставки</div>
                <div class="b-success__item-value" v-html="moduleOrdersHistory.currentOrder.deliverySum"></div>
              </div>
              <div class="b-success__item">
                <div class="b-success__item-title">Стоимость товаров</div>
                <div class="b-success__item-value" v-html="moduleOrdersHistory.currentOrder.basketSum"></div>
              </div>
            </div>
            <div class="b-success__total">
              <div class="b-success__price">
                <div class="b-success__price-title">Итоговая стоимость</div>
                <div class="b-success__price-cost" v-html="moduleOrdersHistory.currentOrder.totalSum"></div>
              </div>
              <div class="b-success__btns">
                <a class="b-success__btn btn--white custom-close" @click="popupClose">Закрыть</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "DetailOrderPopup",
  computed: {
    ...mapState(['moduleOrdersHistory']),
  },
    methods: {
      popupClose()
      {
          Window.popup.close("#more");
      }
    }
}
</script>

<style scoped>

</style>